<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@welcomeToSalesScript">Welcome to Sales Script</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>
<mat-dialog-content>
  <div class="video-wrapper">
    <video class="video" (ended)="vidEnded()" autoplay #bVideo>
      <source src="../../../assets/videos/Sales-script-video.mov" type="video/mp4" />
    </video>
    @if (showReplay) {
      <div class="replayButton video" #replayButton (click)="toggleVideo()" i18n-title title="Replay video"></div>
    }
  </div>
</mat-dialog-content>